import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function Rd1sReducer(state = initialState.rd1s, action: any) {
  switch (action.type) {
    case types.SAVE_RD1S_SUCCESS:
      return action.rd1s;
    default:
      return state;
  }
}
